import { options } from "@fullcalendar/core/preact.js";
import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const BalanceCurve = ({ data }) => {
  const [mainTabination, setMainTabination] = useState(1);

  const parsedData =
    data &&
    data?.map((entry) => ({
      balance: parseFloat(entry?.balance),
      equity: parseFloat(entry?.equity),
      time: new Date(entry?.time).getTime(),
    }));

  const balanceData = parsedData && parsedData?.map((entry) => entry?.balance);
  const timeData = parsedData && parsedData?.map((entry) => entry?.time);
  const equityData = parsedData && parsedData?.map((entry) => entry?.equity);

  const balanceSeries = [
    {
      name: "Balance",
      type: "area",
      data: balanceData,
    },
  ];

  const equitySeries = [
    {
      name: "Equity",
      type: "area",
      data: equityData,
    },
  ];

  const commonOptions = {
    colors: ["#0D56EB"],
    fill: {
      colors: "#0D56EB",
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      type: "area",
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 4,
    },
    grid: {
      borderColor: "#393939",
      strokeDashArray: 0,
    },
    labels: timeData,
    xaxis: {
      type: "datetime",
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
        formatter: (val) => {
          const date = new Date(val);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = String(date.getFullYear()).slice(-2);
          return `${day}-${month}-${year}`;
        },
      },
    },
    yaxis: [
      {
        type: "numeric",
        labels: {
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
    tooltip: {
      enabled: true,
      style: {
        fontSize: "14px",
        fontWeight: "700",
      },
      x: {
        show: true,
        formatter: (val) => {
          const date = new Date(val);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = String(date.getFullYear()).slice(-2);
          return `${day}-${month}-${year} ${date.toLocaleTimeString()}`;
        },
      },
    },
  };

  // useEffect(() => {
  //   setSeries([
  //     {
  //       name: mainTabination === 1 ? "Balance" : "Equity",
  //       type: "area",
  //       data: mainTabination === 1 ? balanceData : equityData,
  //     },
  //   ]);
  // }, [mainTabination, balanceData, equityData]);

  return (
    <div id="chart">
      <div className="chart_tabination">
        <button
          onClick={() => setMainTabination(1)}
          className={
            "chart_tabination_item " + (mainTabination === 1 && " active ")
          }
        >
          Balance
        </button>
        <button
          onClick={() => setMainTabination(2)}
          className={
            "chart_tabination_item " + (mainTabination === 2 && " active ")
          }
        >
          Equity
        </button>
      </div>

      {mainTabination === 1 && (
        <div className="left_chart">
          <ReactApexChart
            options={commonOptions}
            series={balanceSeries}
            height={240}
          />
        </div>
      )}
      {mainTabination === 2 && (
        <div className="right_chart">
          <ReactApexChart
            options={commonOptions}
            series={equitySeries}
            height={240}
          />
        </div>
      )}
    </div>
  );
};

export default BalanceCurve;
